<template>
  <ConfirmationModal
    bodyText=""
    cancelText=""
    continueText="ok"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    headerText="Enable System Insights"
  >
    <p>
      JumpCloud will capture additional information from the system for enhanced reporting.
    </p>
    <p>
      Available for 64-bit systems only.
    </p>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from 'components/Modal/ModalComponents/ConfirmationModal.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

export default {
  name: 'DeviceEnableSystemInsightsModal',

  components: {
    ConfirmationModal,
  },

  props: {
    handleCancel: {
      type: Function,
      default: () => ModalEventBus.close(),
    },

    handleContinue: {
      type: Function,
      default: () => ModalEventBus.close(),
    },
  },
};
</script>
